import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, AuthContext } from '../App';
import { toast } from 'sonner';
import DashboardTab from './DashboardTab';

export default function AdminOverviewPage() {
  const navigate = useNavigate();
  const { hasPermission } = useContext(AuthContext);

  const canSeeApps = hasPermission('applications.view');

  const [applications, setApplications] = useState([]);
  const [students, setStudents]         = useState([]);
  const [cohorts, setCohorts]           = useState([]);
  const [intakePeriods, setIntakePeriods] = useState([]);
  const [selectedIntakeId, setSelectedIntakeId] = useState('all');
  const [loading, setLoading] = useState(true);

  const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

  useEffect(() => { fetchAll(); }, []); // eslint-disable-line

  const fetchAll = async () => {
    try {
      const always = [
        axios.get(`${API}/cohorts`, auth()),
        axios.get(`${API}/students`, auth()).catch(() => ({ data: [] })),
      ];
      const admissions = canSeeApps ? [
        axios.get(`${API}/applications`, auth()),
        axios.get(`${API}/intake-periods`, auth()),
      ] : [];

      const results = await Promise.all([...always, ...admissions]);
      setCohorts(results[0].data);
      setStudents(results[1].data);
      if (canSeeApps) {
        setApplications(results[2].data);
        setIntakePeriods(results[3].data);
      }
    } catch {
      toast.error('Failed to load overview data');
    } finally {
      setLoading(false);
    }
  };

  const handleIntakeChange = async (intakeId) => {
    setSelectedIntakeId(intakeId);
    try {
      const url = intakeId && intakeId !== 'all'
        ? `${API}/applications?intake_id=${intakeId}`
        : `${API}/applications`;
      const res = await axios.get(url, auth());
      setApplications(res.data);
    } catch { /* ignore */ }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-muted-foreground">Loading…</div>
      </div>
    );
  }

  return (
    <div>
      <div className="bg-white border-b px-6 py-4">
        <h1 className="text-xl font-playfair font-bold text-primary">Overview</h1>
        <p className="text-sm text-muted-foreground mt-0.5">
          {canSeeApps ? 'Admissions pipeline and key metrics' : 'Academy at a glance'}
        </p>
      </div>

      <div className="p-6">
        <DashboardTab
          applications={applications}
          students={students}
          cohorts={cohorts}
          intakePeriods={intakePeriods}
          selectedIntakeId={selectedIntakeId}
          onIntakeChange={handleIntakeChange}
          onNavigateToApps={() => navigate('/admin/applications')}
          canSeeApps={canSeeApps}
        />
      </div>
    </div>
  );
}
